//------------------- Search --------------------//

/**
 * @description Get focusable Elements inside of the search container
 *
 * @param {element} searchEl - Search Container
 * @param {element} overlayEl - Search Overlay
 */
function Search(searchEl, overlayEl) {

	this.searchEl = searchEl;
	this.overlayEl = overlayEl;
	this.focusedElBeforeOpen;

	const focusableEls = this.searchEl.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
	this.focusableEls = Array.prototype.slice.call(focusableEls);
	
	this.firstFocusableEl = this.focusableEls[0];
	this.secondFocusableEl = this.focusableEls[1];
	this.lastFocusableEl = this.focusableEls[ this.focusableEls.length - 1 ];

	this.close(); // Reset
}

/**
 * @description Open the Search Modal
 *
 */

Search.prototype.open = function() {

	let Search = this;
	
	const searchContainer = this.searchEl;
	const searchOverlay = this.overlayEl;

	searchContainer.removeAttribute('aria-hidden');
	searchOverlay.removeAttribute('aria-hidden');
	
	setTimeout(function() {
        searchContainer.classList.add('visible');
        searchOverlay.classList.add('visible');
    }, 100);

	this.focusedElBeforeOpen = document.activeElement;

	this.searchEl.addEventListener('keydown', function(e) {
		Search._handleKeyDown(e);
	});

	this.overlayEl.addEventListener('click', function() {
		Search.close();
	});
	
	document.documentElement.classList.add('menu-opening');

	this.secondFocusableEl.focus();
};

/**
 * @description Close the Search Modal
 *
 */

Search.prototype.close = function() {

	this.searchEl.setAttribute('aria-hidden', true);
	this.overlayEl.setAttribute('aria-hidden', true);
    this.searchEl.classList.remove('visible');
    this.overlayEl.classList.remove('visible');

	if ( this.focusedElBeforeOpen ) {
		this.focusedElBeforeOpen.focus();
	}
	
	document.documentElement.classList.remove('menu-opening');
};

/**
 * @description Keyboard Navigation for Search Modal
 *
 */
Search.prototype._handleKeyDown = function(e) {
	const Search = this;
	const KEY_TAB = 9;
	const KEY_ESC = 27;

	function handleBackwardTab() { 
		if ( document.activeElement === Search.firstFocusableEl ) {
			e.preventDefault();
			Search.lastFocusableEl.focus();
		}
	}
	function handleForwardTab() {
		if ( document.activeElement === Search.lastFocusableEl ) {
			e.preventDefault();
			Search.firstFocusableEl.focus();
		}
	}

	switch(e.keyCode) {
    	
	case KEY_TAB:
		if ( Search.focusableEls.length === 1 ) {
			e.preventDefault();
			break;
		} 
		if ( e.shiftKey ) {
			handleBackwardTab();
		} else {
			handleForwardTab();
		}
		break;
	case KEY_ESC:
		Search.close();
		break;
	default:
		break;
	}


};

/**
 * @description Open & Close Search functionality
 *
 */

Search.prototype.addEventListeners = function(openSearchSel, closeSearchSel) {

	const Search = this;

	const opensearchEls = document.querySelectorAll(openSearchSel);
	for ( var i = 0; i < opensearchEls.length; i++ ) {
		opensearchEls[i].addEventListener('click', function() { 
			Search.open();
		});
	}

	var closesearchEls = document.querySelectorAll(closeSearchSel);
	for ( var i = 0; i < closesearchEls.length; i++ ) {
		closesearchEls[i].addEventListener('click', function() {
			Search.close();
		});
	}

};

const navsearchEl = document.querySelector('.search');
const searchOverlay = document.querySelector('.search-overlay');

const mySearch = new Search(navsearchEl, searchOverlay);
mySearch.addEventListeners('.site-header__search', '.search__close');




